
function removeProtocol(path: string): string {
  return path.replace(/http(s)?:/, '');
}

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
const getSizedImageUrl = (src: string, size: string, crop: string | null = null): string => {
  if (!src) {
    const fallbackImgElem: HTMLImageElement = document.querySelector('[data-img-fallback]');
    return fallbackImgElem?.src;
  }

  if (!size) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|pjpg)(\?.*)?$/i);

  if (match) {
    const imageDimensions = size.split('x')
    const setWidth = `&width=${imageDimensions[0]}`;
    const setHeight = imageDimensions[1] ? `&height=${imageDimensions[1]}` : '';
    const setCrop = crop ? `&crop=${crop}` : '';
    const setPrefix = src.split(match[0])[0];
    const setSuffix = match[0];

    return removeProtocol(`${setPrefix}${setSuffix.includes('?') ? setSuffix : setSuffix + '?' }${setWidth}${setHeight}${setCrop}`);
  } else {
    console.error(`Image format not supported: ${src.split('.')[3].split('?')[0]}`);
    return null;
  }
}

const getCroppedCenterURL = (img: string, size: string): string => {
  const unCroppedURL = getSizedImageUrl(img, size);
  const n = unCroppedURL.lastIndexOf('.');
  if(n < 1) return ''
  const imgURL = unCroppedURL.substring(0,n)+'_crop_center'+unCroppedURL.substring(n);
  return imgURL
}

const getSrcSet = (img: string, size?: string, width?: number, height?: number): string => {
  // This logic is a very simple copy of image.liquid where we take
  // a src, width, height, alt, noLazy and class to generate an image
  // with a srcset

  // Get the image dims, either a 'WidthxHeight' string or two separate width/height numbers
  const imageDimensions = size ? size.split('x') : [width?.toString(), height ? height?.toString() : width?.toString()]
  // Parse the width and height from the image dimensions
  const imgWidth = parseInt(imageDimensions[0]);
  // If the height is not provided, use the width for the height
  const imgHeight = imageDimensions[1] ? parseInt(imageDimensions[1]) : imgWidth;

  // Get the array from window.theme object
  let sizesArray = (window as any)['theme'].sizesArray
  // Double the width
  const twoTimes = imgWidth * 2
  // Add the initial width and the two times width to the array
  sizesArray = [...sizesArray, imgWidth, twoTimes]
  // Sort the array from smallest to largest
  sizesArray = sizesArray.sort(function (a, b) {  return a - b;  });
  // Remove values higher than the two times width
  // We do this by creating a new array based on
  // the conditional, and then returning it
  sizesArray = sizesArray.reduce((newSizesArray, sizesWidth) => {
    if (sizesWidth <= twoTimes) {
      newSizesArray = [...newSizesArray, sizesWidth];
    }

    return newSizesArray
  }, [])
  // Use Set to ensure we only have unique values
  sizesArray = [...new Set(sizesArray)]

  return sizesArray.map((sizesWidth) => {
    const aspectRatio = imgWidth / imgHeight;
    const sizesHeight = Math.round(sizesWidth / aspectRatio);
    return `${getSizedImageUrl(img, `${sizesWidth}x${sizesHeight}`)} ${sizesWidth}w`;
  })

}


export {getSizedImageUrl,getCroppedCenterURL,getSrcSet}
